import {
 IProductCatalogue,
 IProductVariant,
} from 'models/ProductManagement'

export const getVariantActiveStatus = (
 variant: IProductVariant,
 isDistributorAdmin: boolean
): boolean =>
 isDistributorAdmin
  ? variant.catalogue_active === true
  : variant.is_active === true

export const getProductActiveSkuCounts = (
 product: IProductCatalogue,
 isDistributorAdmin: boolean
) => {
 const totalSkuCount = product.variants.length
 const activeSkuCount = product.variants.filter((variant) =>
  getVariantActiveStatus(variant, isDistributorAdmin)
 ).length
 return {activeSkuCount, totalSkuCount}
}
